import styles from './CustomizeImageViewerMulti.module.less'
import React from 'react'
import { ImageViewer } from 'antd-mobile'
import Icon from '@/components/Icon/Icon'
import { image as imageUtil } from '@/utils'
import { JSONStringify } from 'lib/tool'

interface ImageItem {
  path: string
  desc: string
}

interface ImageProps {
  images: ImageItem[]
  defaultIndex?: number
  isDownload?: boolean // 是否开启下载
}

const { downloadFile } = imageUtil
const CustomizeImageViewerMulti: React.FC<ImageProps> = (props) => {
  const { images, defaultIndex = 0, isDownload = true } = props
  const pathList: string[] = []
  const descList: string[] = []
  let handler: { close: any } | null = null

  images.forEach((item) => {
    pathList.push(item.path)
    descList.push(item.desc)
  })

  const renderFooter = (_image: string, index: number) => {
    return (
      <div className={styles['footer']}>
        <div className={styles['icon-close']} onClick={() => handler?.close(index)}>
          <Icon name="close" color="#fff" size={24} />
        </div>
        <div className={styles['img-desc']}>{descList[index]}</div>
        {isDownload && (
          <div className={styles['icon-download']} onClick={() => handlerDownload(index)}>
            <Icon name="download" color="#fff" size={36} />
          </div>
        )}
      </div>
    )
  }

  function handlerDownload(index: number) {
    downloadFile(pathList[index], descList[index])
  }

  function handleShow() {
    // 在 app 端打开
    if (window.webview && window.webview.imageViewer) {
      window.webview.imageViewer(
        JSON.stringify({
          defaultIndex,
          images,
        }),
      )
      return
    }

    handler = ImageViewer.Multi.show({
      defaultIndex,
      images: pathList,
      classNames: { mask: 'customize-mask' },
      renderFooter,
    })
  }

  return <>{handleShow()}</>
}

export default CustomizeImageViewerMulti
